// @flow

import { CurrencyEnum, PricingModelEnum, PricingModels } from './types';
import type { PlanPriceDto, PriceGroups, Price } from './types';

export const mapPlanPriceDtosToPrices = (planPriceDtos: PlanPriceDto[]): Price[] => {
  const priceGroups: PriceGroups = {
    OldPrices: [],
    NewPrices: [],
  };

  const mappedPlanPrices = planPriceDtos.map(plan => {
    const planCurrency = Object.keys(CurrencyEnum).find(key => CurrencyEnum[key] === plan.Currency);
    const pricingModel = Object.keys(PricingModelEnum).find(
      key => PricingModelEnum[key] === plan.PricingModel,
    );

    return {
      ...plan,
      Currency: planCurrency,
      PricingModel: pricingModel,
    };
  });

  const normalPlanPrices = mappedPlanPrices.filter(pp => pp.PricingModel === PricingModels.FlatFee);
  const customPlanPrices = mappedPlanPrices.filter(
    pp => pp.PricingModel === PricingModels.Stairstep,
  );

  normalPlanPrices.forEach(planPrice => {
    const codeParts = planPrice.Code.split('-');
    const productCode = codeParts.slice(3).join('-');
    const lookupCode = `${productCode}-${codeParts[1]}`;

    priceGroups.OldPrices.push({
      lookupCode,
      productCode,
      price: ((planPrice.OldPrice || 0) / 100 / planPrice.FrequencyInMonths).toString(),
    });
    priceGroups.NewPrices.push({
      lookupCode,
      productCode,
      price: ((planPrice.Price || 0) / 100 / planPrice.FrequencyInMonths).toString(),
    });
  });

  customPlanPrices.forEach(planPrice => {
    const codeParts = planPrice.Code.split('-');
    const currency = codeParts[1];
    const productCode = [...codeParts.slice(3, -1), 'PR', '3GB'].join('-');
    const lookupCode = `${productCode}-${currency}`;

    const oldTier = planPrice.OldTiers
      ? planPrice.OldTiers.find(tier => tier.StartingUnit === 3)
      : null;
    const newTier = planPrice.Tiers ? planPrice.Tiers.find(tier => tier.StartingUnit === 3) : null;

    if (oldTier) {
      priceGroups.OldPrices.push({
        lookupCode,
        productCode,
        price: ((oldTier.Price || 0) / 100 / planPrice.FrequencyInMonths).toString(),
      });
    }
    if (newTier) {
      priceGroups.NewPrices.push({
        lookupCode,
        productCode,
        price: ((newTier.Price || 0) / 100 / planPrice.FrequencyInMonths).toString(),
      });
    }
  });

  return priceGroups.NewPrices;
};
